import React, { useState } from 'react';
import SalesReportReceipt from "./SalesReportReceipt";
import { getTicketsReporteVentas } from '../sevicios';

const WebThermalPrinterColletions = ({ tickets_ids, logoTicket }: any) => {
  const [tickets, setTickets] = useState([])
  const [loading, setLoading] = useState(false)
  
  const fetchTickets = async () => {
    setLoading(true)
    try {
      const { data } = await getTicketsReporteVentas({ id_movimientos: tickets_ids });
      console.log("🚀 ~ fetch ~ data:", data)
      setTickets(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 900);
    }
  }



  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SalesReportReceipt
        ticketLimit={tickets_ids.length > 10}
        numberOfTicketIds={tickets_ids.length}
        tickets={tickets}
        disabled={tickets_ids.length === 0}
        getTickes={fetchTickets}
        isLoading={loading}
        logoTicket={logoTicket}
      />
    </div>
  )
}

export default WebThermalPrinterColletions

